/**
 * StarIcon — the 5-star rating glyph for ConversationRatingCard (and the
 * filled star reused at 16px in the header menu's "Give feedback" item).
 * Hand-written SVG with the literal Figma path (not lucide-react) — same
 * "match the design's exact path data" precedent as
 * primitives/handoff-icons.tsx.
 */
import type { SVGProps } from 'react';

const STAR_PATH =
  'M12 2l2.9 6.2 6.8.8-5 4.7 1.3 6.8L12 18.3 5.7 20.5 7 13.7l-5-4.7 6.8-.8z';

interface StarIconProps extends Omit<
  SVGProps<SVGSVGElement>,
  'viewBox' | 'children'
> {
  size?: number;
  /** Filled (rating given / hovered / selected) vs. empty outline. */
  filled?: boolean;
}

export function StarIcon({
  size = 20,
  filled = false,
  className,
  ...props
}: StarIconProps) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? '#E36001' : 'none'}
      stroke={filled ? '#E36001' : '#E0D3BE'}
      strokeWidth={filled ? 1.4 : 1.6}
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d={STAR_PATH} />
    </svg>
  );
}
